/**
 * The catalogue. `released` is ordered by actual App Store release — the store IDs
 * ascend chronologically — which is what the catalogue indexes follow.
 * `accent` is sampled from each title's own artwork; it is the only colour a card
 * contributes to the otherwise paper-and-ink interface.
 */
const play = (id) => `https://play.google.com/store/apps/details?id=${id}`;
const ios = (slug, id) => `https://apps.apple.com/us/app/${slug}/id${id}`;

export const games = [
  {
    slug: 'nexion',
    art: 'nexion',
    accent: '#46D6C0',
    genreKey: 'genre.puzzle',
    platforms: ['iOS', 'Android'],
    tagKeys: ['tag.puzzle', 'tag.numbers'],
    stores: { play: play('com.netbyte.matchingnumbers'), ios: ios('nexion-match-the-numbers', '6755531280') },
  },
  {
    slug: 'idle-archive',
    art: 'idle_archive',
    accent: '#6B7ABD',
    genreKey: 'genre.idle',
    platforms: ['iOS', 'Android'],
    tagKeys: ['tag.idle', 'tag.retro'],
    stores: { play: play('com.netbyte.idlearchive'), ios: ios('idle-archive-data-clicker', '6756124079') },
  },
  {
    slug: 'cosmic-synthesis',
    art: 'cosmic_synthesis',
    accent: '#806ABE',
    genreKey: 'genre.idle',
    platforms: ['iOS', 'Android'],
    tagKeys: ['tag.idle', 'tag.space'],
    stores: { play: play('bz.netbyte.cosmicsynthesis'), ios: ios('cosmic-synthesis-idle-builder', '6756239498') },
  },
  {
    slug: 'shadow-node',
    art: 'shadow_node',
    accent: '#5BE08B',
    genreKey: 'genre.idle',
    platforms: ['iOS', 'Android'],
    tagKeys: ['tag.cyberpunk', 'tag.idle'],
    stores: { play: play('bz.netbyte.shadownode'), ios: ios('shadow-node-idle-hacker', '6759072485') },
  },
  {
    slug: 'sudoku-rush',
    art: 'sudoku_rush',
    accent: '#F4D088',
    genreKey: 'genre.puzzle',
    platforms: ['iOS', 'Android'],
    tagKeys: ['tag.puzzle', 'tag.daily'],
    stores: { play: play('bz.netbyte.sudokurush'), ios: ios('sudoku-rush-number-puzzle', '6761775334') },
  },
  {
    slug: 'eco-tycoon',
    art: 'eco_tycoon',
    accent: '#FA9A5C',
    genreKey: 'genre.strategy',
    platforms: ['iOS', 'Android'],
    tagKeys: ['tag.strategy', 'tag.management'],
    stores: { play: play('bz.netbyte.ecotycoon'), ios: ios('eco-tycoon-green-frontier', '6764610657') },
  },
  {
    slug: 'power-idle',
    art: 'power_idle',
    accent: '#59AFCF',
    genreKey: 'genre.idle',
    platforms: ['iOS', 'Android'],
    tagKeys: ['tag.idle', 'tag.management'],
    stores: { play: play('bz.netbyte.poweridle'), ios: ios('power-idle-energy-empire', '6770273931') },
  },
  {
    slug: 'neon-syntax',
    art: 'neon_syntax',
    featured: true,
    accent: '#DE4ABE',
    genreKey: 'genre.survivor',
    platforms: ['Windows', 'Linux', 'macOS', 'iOS', 'Android'],
    tagKeys: ['tag.retro', 'tag.survivor'],
    stores: {},
    upcoming: true,
  },
];

export const releasedGames = games.filter((g) => !g.upcoming);
export const upcomingGames = games.filter((g) => g.upcoming);

/**
 * The title in the hero slot. Set `featured: true` on whichever entry should be
 * there; it falls back to the newest shipped title if nobody is marked.
 */
export const featuredGame = games.find((g) => g.featured) ?? releasedGames[releasedGames.length - 1];
